/**
 * Reports whether a newer application version is available. Splits both dotted versions, bails out unless each has exactly three parts, then compares them component by component and returns false when they are equal.
 *
 * @param latestVersion - Version published as the latest.
 * @param version - Version currently running.
 * @returns True when the latest version is greater than the current one.
 */
const compareVersionApp = (latestVersion: any, version: any) => {
  const arrLatestVersion = latestVersion.split('.');
  const arrVersion = version.split('.');
  if (arrLatestVersion.length !== 3 || arrVersion.length !== 3) {
    return false;
  }
  for (let i = 0; i < arrLatestVersion.length; i += 1) {
    if (Number(arrLatestVersion[i]) > Number(arrVersion[i])) {
      return true;
    }
    if (Number(arrLatestVersion[i]) < Number(arrVersion[i])) {
      return false;
    }
  }
  return false; // latestVersion === version
};

/**
 * Reports whether a version meets or exceeds a target version. Rejects missing inputs, then compares the dotted segments up to the longer length, treating missing or unparsable parts as zero and returning true when all compared parts are equal.
 *
 * @param currentVersion - Version to test.
 * @param targetVersion - Minimum required version.
 * @returns True when the current version is at least the target.
 */
const isVersionAtLeast = (currentVersion: any, targetVersion: any) => {
  if (!currentVersion || !targetVersion) {
    return false;
  }

  const current = String(currentVersion).split('.');
  const target = String(targetVersion).split('.');
  const maxLength = Math.max(current.length, target.length);

  for (let i = 0; i < maxLength; i += 1) {
    const currentPart = Number.parseInt(current[i] ?? '0', 10) || 0;
    const targetPart = Number.parseInt(target[i] ?? '0', 10) || 0;

    if (currentPart !== targetPart) {
      return currentPart > targetPart;
    }
  }

  return true;
};

export { compareVersionApp, isVersionAtLeast };
